module.exports = __webpack_public_path__ + "img/Mask Group 2920@2x.0fdd9694.png";